const Row = ({ label, items }) =>
  items && items.length ? (
    <div className="flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-3">
      <span className="eyebrow text-[0.55rem] text-mocha-dark sm:w-28 shrink-0">{label}</span>
      <span className="text-sm text-ink-soft">{items.join(", ")}</span>
    </div>
  ) : null;

export const NotesPyramid = ({ product }) => {
  const has = (product.notes_top?.length || product.notes_heart?.length || product.notes_base?.length);
  if (!has) return null;
  return (
    <div>
      <p className="eyebrow text-[0.6rem] mb-3">Note olfactive</p>
      <div className="space-y-2.5 border-l-2 border-line pl-4">
        <Row label="Note de vârf" items={product.notes_top} />
        <Row label="Note de mijloc" items={product.notes_heart} />
        <Row label="Note de bază" items={product.notes_base} />
      </div>
    </div>
  );
};
